<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    getStudent_conditions (id) {
      this.$store.dispatch('getStudent_conditions', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getStudent_conditions(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Student_conditions.vue?58a5446d